import { ORDENABLE_PAGE_SIZE } from '@/constants';
import useListService from '@/data/hook/useListService';
import { lessonsQueryKeys } from '@/data/services/querykeys';
import { VersioningStatusEnum } from '@/enums/VersioningStatus';

const PUBLISHABLE_STATUSES = [
  VersioningStatusEnum.VERSIONING,
  VersioningStatusEnum.EDITING,
  VersioningStatusEnum.BETA,
];

export function usePublishableLessons(slug: string) {
  const { results, isLoading } = useListService({
    ...lessonsQueryKeys.nestedList(slug, {
      pageSize: ORDENABLE_PAGE_SIZE,
      status: PUBLISHABLE_STATUSES,
    }),
  });

  const hasPublishableLessons = results.length > 0;

  return { lessons: results, isLoading, hasPublishableLessons };
}
